import React from "react"
import { Helmet } from "react-helmet"

const SiteMetadata = ({
  defaultTitle,
  title,
  canonicalLink,
  imageURL,
  language,
  description,
  favicon,
}) => {
  let imageMeta = []
  if (imageURL) {
    imageMeta.push(<meta key="1" name="image" content={imageURL} />)
    imageMeta.push(<meta key="2" property="og:image" content={imageURL} />)
    imageMeta.push(<meta key="3" property="og:image:width" content="512" />)
    imageMeta.push(<meta key="4" property="og:image:height" content="512" />)
  }

  let canonicalLinkMeta = []
  if (canonicalLink) {
    canonicalLinkMeta.push(
      <link key="1" rel="canonical" href={canonicalLink} />
    )
    canonicalLinkMeta.push(
      <meta key="2" property="og:url" content={canonicalLink} />
    )
  }

  let descriptionMeta = []
  if (description) {
    descriptionMeta.push(
      <meta key="1" name="description" content={description} />
    )
    descriptionMeta.push(
      <meta key="2" property="og:description" content={description} />
    )
  }

  let titleMeta = []
  if (title) {
    titleMeta.push(<meta key="1" property="og:site_name" content={title} />)
    titleMeta.push(<title key="2">{title}</title>)
  }

  return (
    <Helmet
      defer={false}
      defaultTitle={defaultTitle}
      titleTemplate={`%s | ${defaultTitle}`}
    >
      <html lang={language} />
      <link rel="icon" href={favicon} />
      <meta name="docsearch:version" content="2.0" />
      <meta
        name="viewport"
        content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover"
      />

      <meta property="og:type" content="website" />
      <meta property="og:locale" content={language} />

      {titleMeta}
      {descriptionMeta}
      {canonicalLinkMeta}
      {imageMeta}
      <meta name="twitter:card" content="summary" />
    </Helmet>
  )
}

export default SiteMetadata
